<script>
  import Number from "./Number.svelte";

  export let value;
  export let maxItemsAtOnce = 10;
  export let placeholder;
  export let emptyNote = "No items found";
  export let options = [];

  let searchTerm = "";
  let isShowingDropdown = false;
  let selectedOptionIndex = 0;
  let inputElement;

  $: parsedOptions = options.filter(
    d => !searchTerm || d.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onOpen = () => {
    isShowingDropdown = true;
    selectedOptionIndex = 0;
    if (inputElement) inputElement.select();
  };
  const onClose = () => {
    isShowingDropdown = false;
  };

  const keyDiffs = {
    ArrowRight: 1,
    ArrowUp: -1,
    ArrowLeft: -1,
    ArrowDown: 1
  };
  function handleKeydown(event) {
    if (!isShowingDropdown) return;
    if (event.key == "Escape") {
      onClose();
    } else if (event.key == "Enter" && parsedOptions[selectedOptionIndex]) {
      value = parsedOptions[selectedOptionIndex];
      onClose();
    }
    const diff = keyDiffs[event.key];
    if (!diff) return;
    selectedOptionIndex = Math.max(
      0,
      Math.min(parsedOptions.length - 1, selectedOptionIndex + diff)
    );
  }
</script>

<svelte:window on:keydown="{handleKeydown}" />

<div class="c" class:showing="{isShowingDropdown}">
  {#if isShowingDropdown}
    <div class="close-bg" on:click="{onClose}"></div>
  {/if}
  <input
    class="input"
    on:focus="{onOpen}"
    bind:value="{searchTerm}"
    bind:this="{inputElement}"
    {placeholder} />

  <div class="options" class:showing="{isShowingDropdown}">
    {#each parsedOptions.slice(0, maxItemsAtOnce) as option, i}
      <button
        class="option"
        class:focused="{selectedOptionIndex == i}"
        on:focus="{() => (selectedOptionIndex = i)}"
        on:click="{() => {
          value = option;
          onClose();
        }}"
        class:active="{option == value}">
        {option}
      </button>
    {/each}
    {#if !parsedOptions.length}
      <div class="note">{emptyNote}</div>
    {/if}
    {#if parsedOptions.length > maxItemsAtOnce}
      <div class="more">
        <div class="more-text">
          <Number
            number="{parsedOptions.length - maxItemsAtOnce}"
            format=",.0f" />
          more options
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  .c {
    /* position: relative; */
  }
  .c.showing .input,
  .c.showing .options {
    z-index: 1000;
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .close-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(7, 12, 71, 0.9);
    cursor: pointer;
    z-index: 100;
    animation: fadeIn 0.3s ease-out;
  }
  .input {
    position: relative;
    padding: 0.6em 1em;
    font-size: 1em;
    width: 100%;
    background: white;
    /* box-shadow: var(--box-shadow); */
    border: 2px solid #e8eaef;
  }
  .input:focus {
    outline: none;
    border-color: var(--c2);
  }
  ::placeholder {
    color: #a1a1ac;
    font-weight: 100;
  }
  .options {
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 30em;
    max-width: calc(100vw - 4em);
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-between; */
    box-shadow: var(--box-shadow);
    background: #eeeef3;
    padding: 0.6em;
    transform: translateY(103%);
    opacity: 0;
    pointer-events: none;
    transition: transform 0.3s ease-out, opacity 0.1s ease-out;
    z-index: 100;
  }
  .options.showing {
    opacity: 1;
    transform: translateY(100%);
    pointer-events: all;
  }
  .option {
    appearance: none;
    background: none;
    border: none;
    margin: 0.2em;
    padding: 0.5em 0.9em;
    background: white;
    font-size: 0.9em;
    line-height: 1.3;
    cursor: pointer;
    border-radius: 3px;
    border: 2px solid white;
    transition: all 0.2s ease-out;
  }
  .option.focused,
  .option:focus,
  .option:hover {
    color: var(--c2);
    border-color: var(--c2);
    outline: none;
  }
  .option.active {
    color: white;
    background: var(--c2);
    border-color: var(--c2);
  }
  .more {
    width: calc(100% + 1.2em);
    margin: 0.6em -0.6em -0.6em;
    padding: 0.3em 1em 0.5em;
    background: var(--bgc);
    color: #fff;
  }
  .more-text {
    font-size: 0.7em;
    letter-spacing: 0;
    font-style: italic;
  }
  .note {
    margin: 0.6em 1em 0.6em;
    text-align: center;
    font-size: 0.9em;
    font-style: italic;
    opacity: 0.6;
    width: 100%;
  }
</style>
